export function scrollToBottom(container) {
  container.scrollTop = container.scrollHeight
}

export function ignoringBriefDisconnects(element, fn) {
  requestAnimationFrame(() => {
    if (!element.isConnected) fn()
  })
}

export async function keepScroll(container, top, fn) {
  pauseInertiaScroll(container)

  const scrollTop = container.scrollTop
  const scrollHeight = container.scrollHeight

  await fn()

  if (top) {
    container.scrollTop = scrollTop + (container.scrollHeight - scrollHeight)
  } else {
    container.scrollTop = scrollTop
  }

}

export function countElCreate() {
  const countEl = document.createElement("p")
  countEl.classList.add("w-30px", "h-30px", "fs-14", "fw-600", "d-flex", "align-items-center", "justify-content-center", "rounded-5", "bg-black", "text-white", "msg_count", "mb-0")
  countEl.textContent = 1
  countEl.classList.add('msg_count')
  return countEl
}

export function skeletonMessage() {
  return `
    <div class="chat-wrapper h-100 m-auto rounded-3 p-2 d-flex">
      <div class="chat-skeleton w-100 h-100">
        <div class="skeleton-header d-flex align-items-center gap-2 mb-3">
          <div class="avatar-lg w-52px h-52px rounded-circle skeleton"></div>
          <div class="title skeleton"></div>
        </div>
        <div class="chat-body flex-1 overflow-hidden">
          <div class="msg d-flex align-items-end justify-content-end right mb-4">
            <div class="bubble skeleton video"></div>
          </div>
          <div class="msg d-flex align-items-end justify-content-start left mb-4">
            <div class="avatar w-40px h-40px rounded-circle flex-shrink-0 me-2 skeleton"></div>
            <div class="bubble skeleton"></div>
          </div>
          <div class="msg d-flex align-items-end justify-content-start left mb-4">
            <div class="avatar w-40px h-40px rounded-circle flex-shrink-0 me-2 skeleton"></div>
            <div class="bubble skeleton small"></div>
          </div>
          <div class="msg d-flex align-items-end justify-content-start left mb-4">
            <div class="avatar w-40px h-40px rounded-circle flex-shrink-0 me-2 skeleton"></div>
            <div class="bubble skeleton"></div>
          </div>
          <div class="msg d-flex align-items-end justify-content-end right mb-4">
            <div class="bubble skeleton video"></div>
          </div>
          <div class="msg d-flex align-items-end justify-content-start left mb-4">
            <div class="avatar w-40px h-40px rounded-circle flex-shrink-0 me-2 skeleton"></div>
            <div class="bubble skeleton long"></div>
          </div>
          <div class="msg d-flex align-items-end justify-content-end right mb-4">
            <div class="bubble skeleton small"></div>
          </div>
          <div class="msg d-flex align-items-end justify-content-start left mb-4">
            <div class="avatar w-40px h-40px rounded-circle flex-shrink-0 me-2 skeleton"></div>
            <div class="bubble skeleton"></div>
          </div>
          <div class="msg d-flex align-items-end justify-content-start left mb-4">
            <div class="avatar w-40px h-40px rounded-circle flex-shrink-0 me-2 skeleton"></div>
            <div class="bubble skeleton small"></div>
          </div>
          <div class="msg d-flex align-items-end justify-content-start left mb-4">
            <div class="avatar w-40px h-40px rounded-circle flex-shrink-0 me-2 skeleton"></div>
            <div class="bubble skeleton long"></div>
          </div>
          <div class="msg d-flex align-items-end justify-content-end right mb-4">
            <div class="bubble skeleton small"></div>
          </div>
        </div>
        <div class="chat-input skeleton"></div>
      </div>
    </div>
  `;
}